<template>
  <el-switch v-model="value"> </el-switch>
</template>
<script>
export default {
  props: {
  },
  data () {
    return {
      value: false
    };
  },
}
</script>